const Mail = (props: SocialIconProps) => {
  const { className } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" className={className}>
      <rect
        width={62}
        height={62}
        x={1.5}
        y={1}
        className="fill-surface-secondary stroke-skin-stroke"
        strokeWidth={2}
        rx={31}
      />
      <path
        className="fill-skin-primary"
        d="M21.833 42.667c-.733 0-1.36-.261-1.882-.783A2.569 2.569 0 0 1 19.166 40V24c0-.733.262-1.36.785-1.883a2.564 2.564 0 0 1 1.882-.784h21.334c.733 0 1.36.262 1.883.784.522.522.783 1.15.783 1.883v16a2.57 2.57 0 0 1-.782 1.884 2.571 2.571 0 0 1-1.885.783H21.834Zm21.334-16L33.2 32.9a1.366 1.366 0 0 1-.35.15c-.123.033-.24.05-.35.05-.111 0-.228-.017-.35-.05a1.366 1.366 0 0 1-.35-.15l-9.967-6.233V40h21.334V26.667Zm-10.667 4L43.166 24H21.834L32.5 30.667ZM21.833 27v-1.967.034-.018V27Z"
      />
    </svg>
  );
};
export default Mail;
